import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = {
  value?: string;
  onChange: (value: string) => void;
  dataCy?: string;
};
export const FormIsoMonthPicker = (props: Props & FormItemProps<string>) => {
  //
  return (
    <FormItemContainer<string> {...props}>
      <div className="form-iso-month-picker">
        <input
          type="month"
          value={props.value}
          onChange={(event) => {
            props.onChange(event.target.value);
          }}
        ></input>
      </div>
    </FormItemContainer>
  );
};
